import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';

import { SnackbarService } from "../../shared/components/snackbar/snackbar.service";
import { Sherpa } from "../models/sherpa.entity";
import { SherpaRepository } from "../repositories/sherpa.repository";

@Injectable()
export class SherpaResolver  {
  constructor(private readonly sherpaRepository: SherpaRepository,
              private readonly snackbarService: SnackbarService,
              private readonly router: Router,
  ) {
    this.handleError = this.handleError.bind(this);
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Sherpa | undefined> {
    const id = route.paramMap.get('id') ?? '';

    return this.sherpaRepository.findById(id)
      .pipe(catchError(err => this.handleError(err)));
  }

  private handleError(err: HttpErrorResponse): Observable<Sherpa | undefined> {
    if (err.status === 404) {
      this.snackbarService.pushMessage('L\'utilisateur recherché est introuvable', 'error');
    }
    this.router.navigate([ '/users' ]);

    return of(undefined);
  }
}
